import { Api } from '@/interface/api';

/**
 * 获取海报信息
 */
const contestActivityQuery: Api = {
    url: '/api/project/proxy/api/contest_activity/query',
    method: 'get',
};


/**
 * 获取海报分享人信息
 */
const contestActivityQueryShareUser: Api = {
    url: '/api/project/proxy/api/contest_activity/queryShareUser',
    method: 'get',
};

export { contestActivityQuery, contestActivityQueryShareUser};
